module.exports = __webpack_public_path__ + "static/media/rambeau_cloud.6c892688.svg";